<app-process-container>
  <router-outlet></router-outlet>
</app-process-container>
